import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';

import * as S from 'src/modules/programs/stepComponents/styles';
import stepIcon from 'src/public/img/icon-support-type-live.svg';

export const WhatDoesMindfulnessDoStep = withTranslation('cp')(({ t }: WithTranslation) => {
    const pros: string[] = t('week-1.what-does-mindfulness-do.pros', { returnObjects: true });

    return (
        <S.ContentRow>
            <S.ContentColumn md={14}>
                <S.StepHeading />
                <S.StepDescription small>
                    {t('week-1.what-does-mindfulness-do.heading')}
                </S.StepDescription>
                <S.BulletList>
                    {pros.map((pro: string) => (
                        <S.BulletListElement key={pro}>{pro}</S.BulletListElement>
                    ))}
                </S.BulletList>
            </S.ContentColumn>
            <S.ContentColumn md={10}>
                <S.StepIcon iconUrl={stepIcon} />
            </S.ContentColumn>
        </S.ContentRow>
    );
});
